<template>
    <div>
        <!-- ----------------------------版權宣告開始---------------------------- -->
        <footer class="pt-3 cm-footer">
            <a href="#" class="cm-footer-logo">
                <img src="../assets/images/cmi_logo.png">
            </a>
            <div class="d-flex justify-content-center flex-wrap cm-footer-item-list">
                <router-link class="cm-footer-item-md-width" :to="routerIntro">{{$t('footer.Intro')}}</router-link>
                <div class="px-3">|</div>
                <router-link class="cm-footer-item-md-width" :to="routerTermsOfService">{{$t('footer.TermsOfService')}}</router-link>
                <div class="px-3">|</div>
                <router-link class="cm-footer-item-md-width" :to="routerPrivacyPolicy">{{$t('footer.PrivacyPolicy')}}</router-link>
                <div class="px-3">|</div>
                <router-link class="cm-footer-item-md-width" :to="routerCooperationProposal">{{$t('footer.CooperationProposal')}}</router-link>
            </div>
            <div class="cm-footer-copyright">{{$t('footer.CopyRight')}}</div>
        </footer>
        <!-- ----------------------------版權宣告結束---------------------------- -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            routerIntro: process.env.VUE_APP_ROUTER_INTRO,
            routerTermsOfService: process.env.VUE_APP_ROUTER_TERMS_OF_SERVICE,
            routerPrivacyPolicy: process.env.VUE_APP_ROUTER_PRIVACY_POLICY,
            routerCooperationProposal: process.env.VUE_APP_ROUTER_COOPERATION_PROPOSAL
        }
    }
}
</script>